<template>
    <div class="page">
        <a-card :bordered="false" :bodyStyle="{ padding: '16px 0', height: '100%' }" :style="{ height: '100%' }">
            <div class="user-settings-info-main">
                <div class="user-settings-info-left">
                    <a-menu :style="{ border: '0'}"
                            :defaultSelectedKeys="[$route.path]"
                            mode="inline">
                            <template v-for="route in initPageRoutes">
                              <a-menu-item :key="route.path">
                                <router-link exact :to="route.path">{{$t('setting.' + route.meta.title)}}</router-link>
                              </a-menu-item>
                            </template>
                        <!-- <a-menu-item key="/user/security"><router-link exact to="/user/security">安全设置</router-link></a-menu-item>
                        <a-menu-item key="/user/setting"><router-link exact to="/user/setting">主题设置</router-link></a-menu-item> -->
                        <!-- <a-menu-item key="3"><router-link to="/user/set">系统设置</router-link></a-menu-item> -->
                    </a-menu>
                </div>
                <div class="user-settings-info-right">
                    <div class="user-settings-info-title">
                        <span>{{$t('setting.' + $route.meta.title)}}</span>
                    </div>
                    <!-- <router-view></router-view> -->
                    <transition
                      mode="out-in"
                      leave-active-class="animated zoomOut"
                      enter-active-class="animated zoomIn">
                      <router-view />
                    </transition>
                </div>
            </div>
        </a-card>
    </div>


</template>

<script>
    export default {
        name: 'UserSetting',
        data() {
            return {
              initPageRoutes: {}
            }
        },
        methods: {
          getInitRoutes () {
            this.initPageRoutes = this.$router.options.routes.find((route) => route.path === '/').children.find((route) => route.path === '/user').children
            // console.log(this.initPageRoutes)
          }
        },
        created () {
          this.getInitRoutes()
        }
    }
</script>


<style lang="less" scoped>
@import '../../theme/color.less';
.rourer-link-exact-active {
  color: @primary-color;
}

.ant-menu-item a {
  color: @heading-color !important;
}
.ant-menu-item-selected {
  background-color: @normal-color !important;
  // border-left: 2px solid @primary-color;
  box-sizing: border-box !important;
  a {
    color: @primary-color !important;
    &:hover {
      color: @primary-color !important;
    }
  }
}

    .user-settings-info-main {
        width: 100%;
        display: flex;
        height: 80vh;
        overflow: auto;
    }

    .user-settings-info-left {
        width: 224px;
        height: 80vh;
        min-height: 280px;
        overflow: hidden;
        border-right: 1px solid #e8e8e8;
        color: @primary-color;
        text-align: center;
    }

    .user-settings-info-right {
        padding: 20px 40px;
    }

    .user-settings-info-right {
        flex: 1 1;
        padding: 8px 40px;
    }

    .user-settings-info-title {
        color: rgba(0, 0, 0, .85);
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 12px;
    }

    .user-settings-info-view {
        padding-top: 12px;
    }

</style>